import { combineReducers } from 'redux';

import { machineAddOptionsReducer } from 'home/Machines/MachineAdd/reducers/machineAddOptions.reducer';
import { machineAddStageReducer } from 'home/Machines/MachineAdd/reducers/machineAddStage.reducer';

export const machineAddReducer = combineReducers({
  machineAddOptions: machineAddOptionsReducer,
  machineAddStage: machineAddStageReducer,
});
